import { BlogIndexPage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/title/blog/")({
  component: () => <BlogIndexPage portal="title" basePath="/title/blog" />,
});
